import logo from '../assets/logo.png';
import circle from '../assets/circle.svg';
import oladoc from '../assets/oladoc.png'
import dentalimplant from '../assets/dentalimplant.jpg'
import dentures from '../assets/dentures.webp'
import about01 from '../assets/about01.png'
import email from '../assets/email.png'
import mobile from '../assets/mobile.png'
import DrHaseeb from '../assets/DrHaseeb.jpg'
import DrMaaz from '../assets/DrMaaz.jpeg'
import DrRameez from '../assets/DrRamez.jpeg'
import DrRozina from '../assets/DrRozina.jpeg'
import DrShehzad from '../assets/DrShehzad.jpeg'
import eman from '../assets/eman.png';
import bgIMG from '../assets/bgIMG.png';
import rootcanal from '../assets/rootcanal.jpg';
import bgWhite from '../assets/bgWhite.png';
import scaling from '../assets/scaling.png'
import white from '../assets/white.png'
import marham from '../assets/marham.png'
import healthwire from '../assets/healthwire.jpg'
import instacare from '../assets/instacare.png'
import invaslign from '../assets/invisalign.jpeg'
// import eman2 from '../assets/eman2.png'
import wisdom from '../assets/wisdom.jpg'
import fillings from '../assets/fillings.jpg'
import shifaam from '../assets/shifaam.png'
import bridges from '../assets/dental-bridges.jpg'

export default {
    logo,
    oladoc,
    shifaam,
    circle,
    wisdom,
    bgIMG,
    bgWhite,
    invaslign,
    bridges,
    about01,
    marham,
    instacare,
    healthwire,
    mobile,
    rootcanal,
    dentalimplant,
    dentures,
    DrHaseeb,
    DrMaaz,
    DrRameez,
    DrRozina,
    DrShehzad,
    eman,
    scaling,
    white,
    
    email,
    fillings
}